module.exports = __webpack_public_path__ + "img/tr_get.3074114.png";